<ng-container *ngIf="status !== 'complete' && status !== 'fail'">
    <h1 *ngIf="title">{{ title }}</h1>
    <p *ngIf="subtitle">{{ subtitle }}</p>
    <div #stepsHeader class="steps-header" *ngIf="steps?.length && steps.length > 1">
        <div class="step-label-wrapper" *ngFor="let step of steps; let i = index;">
            <div class="step-label"
                [ngClass]="{'active': currentStep.index === i, 'completed': step.status === 'completed'}">
                <div #stepLabelIndex class="step-label-index">{{ i+1 }}</div>
                <div class="step-label-text">{{ step.label }}</div>
            </div>
            <div #stepLine class="step-line" [class.active]="step.status === 'completed'"></div>
        </div>
    </div>
    <div class="steps-body">
        <ng-container *ngIf="currentStep.step">
            <ng-container *ngTemplateOutlet="currentStep.step?.content || null">
            </ng-container>
        </ng-container>
    </div>
</ng-container>

<ng-container *ngIf="status === 'complete'">
    <ng-container *ngTemplateOutlet="complete?.content || null"></ng-container>
</ng-container>
<ng-container *ngIf="status === 'fail'">
    <ng-container *ngTemplateOutlet="fail?.content || null"></ng-container>
</ng-container>

<div class="steps-footer" [class.only-next]="currentStep.index === 0 || status === 'complete' || status === 'fail'">
    <ng-container *ngIf="status !== 'complete' && status !== 'fail'">
        <button class="mpro-btn mpro-btn-secondary" (click)="back()" *ngIf="currentStep.index !== 0"
            [disabled]="status === 'loading'">
            {{ getButtonLabel('back') }}
        </button>
        <button class="mpro-btn mpro-btn-primary" (click)="next()" *ngIf="currentStep.index !== steps.length - 1"
            [disabled]="currentStep.step?.nextStepDisabled || status === 'loading'">
            {{ getButtonLabel('next') }}
        </button>
        <button class="mpro-btn mpro-btn-primary" (click)="finish()" *ngIf="currentStep.index === steps.length - 1"
            [disabled]="currentStep.step?.nextStepDisabled || status === 'loading'">
            {{ getButtonLabel('finish') }}
        </button>
    </ng-container>
    <button *ngIf="status === 'complete' || status === 'fail'" class="mpro-btn mpro-btn-primary" (click)="close()">
        {{ getButtonLabel('close') }}
    </button>
</div>

<mpro-loading *ngIf="status === 'loading'"></mpro-loading>
